export default __webpack_public_path__ + "2f19b962bff74cfc42d97944a8ab39e6.png";